import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminConfigPanel from '../components/AdminConfigPanel';

/**
 * Admin Configuration Page
 * Full-page admin settings management
 * Only accessible to admin users
 */
const AdminPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is admin
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.role !== 'admin') {
      navigate('/dashboard'); // Redirect if not admin
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-100">
      <AdminConfigPanel />
    </div>
  );
};

export default AdminPage;
